<div class="anyagok">

  <div class="anyagok__head">
    <h1 class="stk-page-title">Anyagok</h1>
    <div class="stk-page-sub">Nyomtatási anyagok és csomagolóanyagok árai — ezekből számol a rendszer költséget.</div>
  </div>

  <div class="mat-grid">

    <!-- Nyomtatási anyagok (filamentek) -->
    <div class="mat-card">
      <div class="mat-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"></circle><circle cx="12" cy="12" r="3.2"></circle></svg>
        <h3 class="mat-card__title">Nyomtatási anyagok</h3>
        <span class="mat-card__unit">Ft / kg</span>
      </div>
      <div class="mat-row" *ngFor="let f of filaments">
        <div class="mat-row__main">
          <div class="mat-row__name">{{ f.name }}</div>
          <div class="mat-row__sub mat-row__sub--usage">{{ f.usageLabel }}</div>
        </div>
        <div class="mat-row__price">{{ priceLabel(f) }} <span>Ft/kg</span></div>
        <button type="button" class="mat-icon-btn mat-icon-btn--edit" title="Szerkesztés" (click)="openEdit('filament', f)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 h4 L18.5 9.5 a2 2 0 0 0 -3 -3 L5 17 Z"></path><line x1="14" y1="7" x2="17" y2="10"></line></svg>
        </button>
        <button type="button" class="mat-icon-btn mat-icon-btn--del" title="Anyag törlése" (click)="remove('filament', f)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
        </button>
      </div>
      <div class="mat-empty" *ngIf="!loading && filaments.length === 0">Még nincs nyomtatási anyag rögzítve.</div>
      <button type="button" class="mat-add" (click)="add('filament')">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        Új anyag hozzáadása
      </button>
    </div>

    <!-- Csomagolás (dobozok / címkék) -->
    <div class="mat-card">
      <div class="mat-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2"></rect><polyline points="3,7 12,3 21,7"></polyline><line x1="12" y1="12" x2="12" y2="15"></line></svg>
        <h3 class="mat-card__title">Csomagolás</h3>
        <span class="mat-card__unit">Ft / db</span>
      </div>
      <div class="mat-row" *ngFor="let b of boxes">
        <div class="mat-row__main">
          <div class="mat-row__name">{{ b.name }}</div>
          <div class="mat-row__sub">{{ b.dims }}</div>
        </div>
        <div class="mat-row__price">{{ priceLabel(b) }} <span>Ft/db</span></div>
        <button type="button" class="mat-icon-btn mat-icon-btn--edit" title="Szerkesztés" (click)="openEdit('box', b)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 h4 L18.5 9.5 a2 2 0 0 0 -3 -3 L5 17 Z"></path><line x1="14" y1="7" x2="17" y2="10"></line></svg>
        </button>
        <button type="button" class="mat-icon-btn mat-icon-btn--del" title="Törlés" (click)="remove('box', b)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
        </button>
      </div>
      <div class="mat-empty" *ngIf="!loading && boxes.length === 0">Még nincs csomagolóanyag rögzítve.</div>
      <button type="button" class="mat-add" (click)="add('box')">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        Új doboz / címke hozzáadása
      </button>
    </div>

  </div>

  <div class="mat-note">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16"></line><circle cx="12" cy="8" r="0.4" fill="#707870"></circle></svg>
    <span>Az itt megadott árakból számolja a rendszer a termékek anyagköltségét és a csomagok szállítási költségét a rendelés oldalon.</span>
  </div>

  <!-- matEdit modál (21-kovetkezo-kepernyo.html) -->
  <div class="stk-modal-overlay" *ngIf="edit" (click)="cancelEdit()">
    <div class="stk-modal" (click)="$event.stopPropagation()">
      <div class="stk-modal-kicker">{{ editKicker }}</div>
      <div class="stk-modal-title">{{ editTitle }}</div>
      <div class="stk-modal-sub">{{ editIdLabel }}</div>

      <label class="stk-label">Név</label>
      <input class="stk-input mat-edit__field" [value]="edit.draft.name" (input)="onNameInput($event)" placeholder="pl. PLA">

      <ng-container *ngIf="edit.kind === 'box'">
        <label class="stk-label">Méret / leírás</label>
        <input class="stk-input mat-edit__field" [value]="edit.draft.dims" (input)="onDimsInput($event)" placeholder="pl. 15 × 20 × 8 cm">
      </ng-container>

      <label class="stk-label">Ár</label>
      <div class="mat-edit__price-row">
        <input class="stk-input mat-edit__price" [value]="edit.draft.price" (input)="onPriceInput($event)" placeholder="0">
        <span class="mat-edit__unit">{{ editUnit }}</span>
      </div>

      <div class="stk-info-bar mat-edit__usage" *ngIf="editUsageCount > 0">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5C7A2E" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16.5"></line><circle cx="12" cy="7.8" r="0.5" fill="#5C7A2E"></circle></svg>
        <span>{{ editUsageLabel }}</span>
      </div>

      <div class="mat-edit__actions">
        <button type="button" class="mat-edit__cancel" (click)="cancelEdit()">Mégse</button>
        <button type="button" class="mat-edit__save" [class.mat-edit__save--disabled]="!editValid || saving" [disabled]="!editValid || saving" (click)="saveEdit()">Mentés</button>
      </div>
    </div>
  </div>

</div>
